import React from "react";
import { FooterBtnProps } from "src/interfaces/functionalComponentInterface";
import { Button } from "./ui/button";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "./ui/tooltip";

const FooterBtn: React.FC<FooterBtnProps> = ({
  handleNext,
  handlePrev,
  handleRestart,
  currentStep,
  isButtonDisabled,
  tooltipMessage,
}) => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 z-40 bg-gray-100 p-6 md:p-8">
      <div className="w-full max-w-[1240px] px-8 mx-auto">
        <div
          className={`flex items-center ${
            currentStep === 3 ? "justify-center" : "justify-between"
          }`}
        >
          {currentStep !== 3 ? (
            <>
              <Button
                className="w-28 md:h-10 md:w-38 border text-base rounded-sm font-medium transition-all duration-400 ease-in-out bg-[#FDFCF7] text-primary hover:bg-[#F6F6F6] border-primary btn-inset-shadow"
                onClick={handlePrev}
                disabled={currentStep === 1}
              >
                Prev
              </Button>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="w-28 md:w-38 relative">
                      <Button
                        className="w-full md:h-10 text-white bg-primary hover:bg-primary-foreground font-medium text-base rounded-sm"
                        onClick={handleNext}
                        disabled={isButtonDisabled}
                      >
                        Next
                      </Button>
                    </div>
                  </TooltipTrigger>
                  {isButtonDisabled && tooltipMessage && (
                    <TooltipContent
                      side="top"
                      className=" text-white bg-primary"
                    >
                      {tooltipMessage}
                    </TooltipContent>
                  )}
                </Tooltip>
              </TooltipProvider>
            </>
          ) : null}
          {currentStep === 3 ? (
            <Button
              className="w-28 md:w-38 md:h-10 rounded-sm text-white bg-primary hover:bg-primary-foreground font-medium text-base"
              onClick={handleRestart}
            >
              Restart
            </Button>
          ) : null}
        </div>
      </div>
    </footer>
  );
};

export default FooterBtn;
